import React, { FunctionComponent } from 'react';
import { Progress } from './Progress';

export const Loader: FunctionComponent = () => {
  return (
    <React.Fragment>
      <Progress isAnimating />
    </React.Fragment>
  );
};
